<div id="header-wrapper">
  <h6 id="tracker-subtitle">Choisissez la configuration de trackers que vous souhaitez proposer à vos patients lorsqu’ils téléchargent l’application pour la première fois. Cette configuration de trackers peut ensuite être modifiée de façon individuelle dans chaque fiche patient.</h6>
</div>
<msd-tracker-manager [dietitian]="dietitian"
                     [mode]="'DIETITIAN'"
                     [maxTrackers]="maxTrackers"
                     [withNewTrackerButton]="false">
</msd-tracker-manager>
